'use es6';

import { memo } from 'react';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { StyledThead, StyledTh } from './CrossTabStyledComponents';
import { EncodingTypes } from '../crossTabRecords';
import { TOTAL_KEY_FIELD, SUBTOTAL_KEY_FIELD } from '../dataHelpers/totals';
import { SUBTOTAL_DISPLAY_HINT } from '../crossTabVisualization';
import { FOLD_VALUE_FIELD } from '../../../transforms/fold';
import { jsx as _jsx } from "react/jsx-runtime";
const isTotalsColumn = (encodingLabel, rowTotal) => encodingLabel.headerData && (encodingLabel.headerData.keySeq() && encodingLabel.headerData.keySeq().first() === TOTAL_KEY_FIELD || encodingLabel.headerData.first() === rowTotal.first());
const isSubtotalsColumn = encodingLabel => encodingLabel && encodingLabel.headerData && encodingLabel.headerData.get(SUBTOTAL_KEY_FIELD);
const getSubtotalDisplayHint = encodingLabel => encodingLabel && encodingLabel.headerData && encodingLabel.headerData.get(SUBTOTAL_DISPLAY_HINT);
const CrossTabHeader = ({
  visualization,
  headerEncodingsWithLabels
}) => {
  const {
    columns,
    rowTotal,
    values
  } = visualization;
  const isFolded = values.getIn([0, 'field']) === FOLD_VALUE_FIELD;
  return /*#__PURE__*/_jsx(StyledThead, {
    children: headerEncodingsWithLabels.toList().map((encoding, encodingIndex) => {
      const isLastRow = encodingIndex === headerEncodingsWithLabels.count() - 1;
      return /*#__PURE__*/_jsx("tr", {
        children: encoding.get('encodingLabels').map((encodingLabel, labelIndex) => {
          const isRowEncoding = encodingLabel.get('encodingType') === EncodingTypes.row;
          const totalsColumn = isTotalsColumn(encodingLabel, rowTotal);
          const subtotalColumn = isSubtotalsColumn(encodingLabel);
          const subtotalDisplayHint = getSubtotalDisplayHint(encodingLabel);
          let rowSpan = undefined;
          if (isRowEncoding) {
            rowSpan = columns.count() + 1;
          }
          if (totalsColumn) {
            rowSpan = isFolded ? columns.count() : columns.count() + 1;
          }
          if (subtotalColumn && subtotalDisplayHint) {
            rowSpan = subtotalDisplayHint;
          }
          const colSpan = isRowEncoding || totalsColumn && !isFolded ? undefined : encodingLabel.get('encodingSize');
          if (totalsColumn && isLastRow && !isFolded || subtotalColumn && !subtotalDisplayHint) {
            return null;
          }
          return /*#__PURE__*/_jsx(StyledTh, {
            textAlign: isLastRow || isRowEncoding ? encodingLabel.get('align') : 'center',
            colSpan: colSpan,
            rowSpan: rowSpan,
            children: /*#__PURE__*/_jsx(TruncateString, {
              children: encodingLabel.get('label') || ''
            })
          }, labelIndex);
        })
      }, encodingIndex);
    })
  });
};
export default /*#__PURE__*/memo(CrossTabHeader);